export function parseAppointmentErrorMessage(message: string): { code: string | null; text: string } {
  const pipe = message.indexOf("|");
  if (pipe > 0 && message.startsWith("APPT_")) {
    return { code: message.slice(0, pipe), text: message.slice(pipe + 1) };
  }
  return { code: null, text: message };
}

export const APPOINTMENT_ERROR_TITLES: Record<string, string> = {
  APPT_SLOT_ALREADY_BOOKED: "Slot already booked",
  APPT_SLOT_NOT_VISIBLE: "Slot not available",
  APPT_SLOT_CANCELLED: "Slot cancelled",
  APPT_SLOT_DELETED: "Slot removed",
  APPT_SLOT_EXPIRED: "Slot expired",
  APPT_SLOT_NOT_AVAILABLE: "Slot unavailable",
  APPT_SLOT_OVERLAP: "Time slot overlaps",
  APPT_ALREADY_HAS_BOOKING: "Already booked",
  APPT_FEE_NOT_SET: "Fee not configured",
  APPT_PAYMENT_REQUIRED: "Payment required",
};

export function resolveAppointmentErrorNotification(
  rawMessage: string,
  fallbackTitle = "Something went wrong",
): { isAppointmentError: boolean; title: string; message: string } {
  const { code, text } = parseAppointmentErrorMessage(rawMessage);
  if (!code) {
    return { isAppointmentError: false, title: fallbackTitle, message: rawMessage };
  }
  return {
    isAppointmentError: true,
    title: APPOINTMENT_ERROR_TITLES[code] ?? fallbackTitle,
    message: text || rawMessage,
  };
}
